export default "__VITE_ASSET__BtFqX2LS__"